import React from "react";
import { useSelector } from "react-redux";
import CelebrationButton from "@/components/ui/CelebrationButton/CelebrationButton";
import Select from "react-select";

const AddModal = ({ open, onClose, formData, handleInputChange, onSave,errors }) => {
  if (!open) return null;

  const { countryList } = useSelector((state) => state.common);
  const { isAnimate } = useSelector((state) => state.toast);

  const selectContary = (selected) => {
    handleInputChange({
      target: { name: "isoCode", value: selected?.value },
    });
    handleInputChange({ target: { name: "country", value: selected?.label } });
  };

  const options = (countryList || [])?.map((loc) => {
    const match = (loc.incoterm || "").match(/\(([^)]+)\)/);
    const code = match ? match[1] : null;
    return {
      value: code,
      label: loc.incoterm,
    };
  });

  const inputClass =
    "w-full px-4 py-2.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg text-sm text-slate-900 dark:text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all  disabled:bg-gray-200 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed";
  const selectClass =
    "w-full px-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg text-sm text-slate-900 dark:text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all  disabled:bg-gray-200 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed";
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-12 overflow-auto">
      <div className="bg-white dark:bg-slate-800 w-[520px] rounded-md shadow-lg">
        {/* Header */}
        <div className="px-4 py-2 bg-sky-500 text-white font-medium rounded-t-md">
          Location Information
        </div>

        <div className="bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800">
          {/* Body */}
          <div className="p-5 space-y-4">
            <div className="grid grid-cols-12 items-center gap-2">
              <label className="col-span-3 text-sm font-medium text-slate-600 dark:text-slate-400">
                Country ISO Code: <span className="text-red-500">*</span>
              </label>
              <div className="col-span-9">
                <Select
                  options={options}
                  value={options?.find(
                    (opt) => opt.value === formData?.isoCode,
                  )}
                  onChange={(selected) => selectContary(selected)}
                  placeholder="Select Country"
                  classNames={{
                    control: (state) =>
                      `min-h-[38px] rounded-md border  bg-white dark:bg-slate-800 text-slate-900 dark:text-white 
                       ${state.isFocused ? "border-[#0072FF] ring-1 ring-[#0072FF]" : "border-slate-300 dark:border-slate-700"} ${errors?.country ? " border border-red-500" : "dark:bg-slate-800"}`,
                    menu: () =>
                      "bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-700",
                    option: ({ isFocused, isSelected }) =>
                      `cursor-pointer px-3 py-2   ${isSelected ? "bg-[#0072FF] text-white" : ""}
                        ${isFocused && !isSelected ? "bg-slate-100 dark:bg-slate-700" : ""}  text-slate-900 dark:text-white`,

                    singleValue: () => "text-slate-900 dark:text-white",
                    placeholder: () => "text-slate-400 dark:text-slate-500",
                  }}
                />
                {errors?.country && (
                  <span className="text-red-500 text-[11px]">
                    {errors?.country}
                  </span>
                )}
              </div>
            </div>

            {/* Port Name */}
            <div className="grid grid-cols-12 items-center gap-2">
              <label className="col-span-3 text-sm font-medium text-slate-600 dark:text-slate-400">
                State Name:
              </label>
              <div className="col-span-9">
                <input
                  type="text"
                  name="stateName"
                  className={inputClass}
                  // value={formData?.stateName || ""}
                  // onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="grid grid-cols-12 items-center gap-2">
              <label className="col-span-3 text-sm font-medium text-slate-600 dark:text-slate-400">
                LOC Code: <span className="text-red-500">*</span>
              </label>
              <div className="col-span-9">
                <input
                  type="text"
                  name="locCode"
                  className={
                    inputClass +
                    (errors?.locCode ? " border border-red-500" : "")
                  }
                  value={formData?.locCode || ""}
                  onChange={handleInputChange}
                />
                {errors?.locCode && (
                  <span className="text-red-500 text-[11px]">
                    {errors?.locCode}
                  </span>
                )}
              </div>
            </div>
            <div className="grid grid-cols-12 items-center gap-2">
              <label className="col-span-3 text-sm font-medium text-slate-600 dark:text-slate-400">
                Area Name: <span className="text-red-500">*</span>
              </label>
              <div className="col-span-9">
                <input
                  type="text"
                  name="stateName"
                  className={
                    inputClass +
                    (errors?.stateName ? " border border-red-500" : "")
                  }
                  value={formData?.stateName || ""}
                  onChange={handleInputChange}
                />
                {errors?.stateName && (
                  <span className="text-red-500 text-[11px]">
                    {errors?.stateName}
                  </span>
                )}
              </div>
            </div>
            <div className="grid grid-cols-12 gap-2">
              <label className="col-span-3 text-sm font-medium text-slate-600 dark:text-slate-400">
                Notes:
              </label>
              <div className="col-span-9">
                <textarea
                  rows={3}
                  name="description"
                  className={inputClass}
                  value={formData?.description || ""}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="text-xs text-slate-500">
              * Marks are mandatory fields.
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-center gap-2 px-4 py-3 border-t dark:border-slate-700">
          <CelebrationButton
            onClick={() => onSave()}
            label={Number(formData?.id) ? "Update" : "Save"}
            className="bg-green-600 text-white px-4 py-1 rounded-md text-sm"
            icon={<></>}
            isSuccess={isAnimate}
          />

          <button
            onClick={onClose}
            className="bg-green-600 text-white px-4 py-1 rounded-md text-sm"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddModal;

